<script lang="ts">
	import '../app.css';
	import '../font.css';
	import 'tippy.js/dist/tippy.css';
	import 'tippy.js/themes/light.css';
	import 'tippy.js/themes/material.css';
	import 'tippy.js/themes/light-border.css';

	import RootModal from '$lib/utils/components/RootModal.svelte';
	import Auth from '$lib/features/auth/components/Auth.svelte';
	import NavBar from '$lib/components/NavBar/NavBar.svelte';
	import GlobalFAB from '$lib/components/GlobalFAB.svelte';
	import TopAppBar from '$lib/components/TopAppBar.svelte';

	import { auth_state } from '$lib/features/auth/state/auth_state';
	import { Loc, locale_state } from '$lib/tools/locale.svelte';
	import * as Sentry from '@sentry/svelte';
	import { toast, Toasts } from 'svoast';
	import { page } from '$app/state';
	import { onMount } from 'svelte';

	let { children } = $props();

	const pathname = $derived(page.url.pathname as string);
	const is_offline = $state({ value: typeof window === 'undefined' ? false : !navigator.onLine });

	onMount(() => {
		const on_auth_unsub = auth_state.on_auth('/layout', async () => {
			const { initiate_main_states } = await import('$lib/states/initiate_main_states');
			initiate_main_states();
		});

		Sentry.init({
			dsn: import.meta.env.VITE_SENTRY_DSN,
			integrations: [],
			tracesSampleRate: 0
		});

		const handle_online = () => (is_offline.value = false);
		const handle_offline = () => (is_offline.value = true);
		window.addEventListener('online', handle_online);
		window.addEventListener('offline', handle_offline);

		return () => {
			on_auth_unsub();
			window.removeEventListener('online', handle_online);
			window.removeEventListener('offline', handle_offline);
		};
	});

	$effect(() => {
		if (!toast.toasts.length) {
			const popover = document.getElementById('popover-toast');
			popover?.hidePopover?.();
		}
	});
</script>

<svelte:head>
	<title>Shaggaga Sellers</title>
</svelte:head>

<RootModal />
<div dir={locale_state.dir} class="relative min-h-[100vdh] w-full">
	<div class="flex min-h-screen w-full flex-col">
		{#if auth_state.value || auth_state.is_authenticated_offline}
			<TopAppBar />
		{/if}

		{#if is_offline.value && (auth_state.value || auth_state.is_authenticated_offline)}
			<div role="status" class="w-full bg-warning px-4 py-1.5 text-center">
				<span class="text-xs font-semibold text-warning-foreground">{Loc('offline_banner')}</span>
			</div>
		{/if}

		<main
			class="mx-auto w-full flex-1 {auth_state.value || auth_state.is_authenticated_offline
				? 'px-3 pb-[calc(8rem+env(safe-area-inset-bottom))] pt-2 sm:px-4 lg:max-w-[1100px]'
				: 'px-0 pb-0 pt-0'}"
		>
			{#if auth_state.is_authenticated_offline === true || auth_state.value === true || pathname === '/privacy' || pathname === '/test'}
				{@render children()}
			{:else}
				<Auth />
			{/if}
		</main>
		{#if auth_state.is_authenticated_offline === true || auth_state.value === true}
			<NavBar />
			<GlobalFAB />
		{/if}
		<div id="popover-toast" popover="auto">
			<Toasts position="top-center" />
		</div>
	</div>
</div>
